import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Spinner } from 'reactstrap';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import WorkGeneralInfoForm from './Sections/WorkGeneralInfoForm';
import WorkLocationMap from './Sections/WorkLocationMap';
import WorkScheduledActivitiesGrid from './Sections/WorkScheduledActivitiesGrid';
import WorkMeasurementDetailsGrid from './Sections/WorkMeasurementDetailsGrid';
import { getWorkOrderApi } from '../../../helpers/work_order/api_helper';
import { getWaterRights } from '../../../helpers/water_rights/backend_helper';

const WorkDetails = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [workData, setWorkData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: Icons.house },
		{ to: '#', label: 'Medio Ambiente', icon: Icons.environment },
		{ to: '/water-rights/list', label: 'Derechos de Agua', icon: Icons.water },
	];

	useEffect(() => {
		if (!id) return;
		let cancelled = false;
		setIsLoading(true);

		getWorkOrderApi(id)
			.then(async res => {
				const workOrder = res.data || res;
				const waterRightId = workOrder.water_right_id;
				const waterRight = waterRightId
					? await getWaterRights(waterRightId).then(r => r.data || r).catch(() => null)
					: null;

				if (!cancelled) {
					setWorkData({
						_id: workOrder._id,
						work_code: workOrder.work_order_code,
						establishment: waterRight?.establishment?.name || '-',
						region: waterRight?.region?.name || '-',
						commune: waterRight?.commune?.name || '-',
						water_right_status: waterRight?.water_rights_status?.name || '-',
						water_right_number: waterRight?.file_number || '-',
						nature_classification: waterRight?.water_right_type?.name || '-',
						reporting_type: workOrder.reporting_type?.name || '-',
						reporting_frequency: workOrder.reporting_frequency?.name || '-',
						measurement_frequency: workOrder.measurement_frequency?.name || '-',
						position: workOrder.position?.name || '-',
						work_order_status: workOrder.work_order_status?.name || '-',
						reporting_start_date: workOrder.reporting_start_date,
						file: workOrder.file || null,
						latitude: waterRight?.establishment?.latitude || null,
						longitude: waterRight?.establishment?.longitude || null,
					});
				}
			})
			.catch(err => console.error('Error al cargar detalles de obra:', err))
			.finally(() => { if (!cancelled) setIsLoading(false); });

		return () => { cancelled = true; };
	}, [id]);

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Detalle de Obra'
						links={breadcrumbLinks}
					/>

					{/* Fila 1-2: Datos Generales + Mapa */}				
					{isLoading ? (
						<div className='d-flex justify-content-center align-items-center py-5'>
							<Spinner color='primary' />
						</div>
					) : (
						<>					<Row className='mb-3'>
							<Col md={6}>
								<Card className='h-100'>
									<CardHeader>
										<h5 className='card-title mb-0'>Datos Generales</h5>
									</CardHeader>
									<CardBody>
										<WorkGeneralInfoForm workData={workData} />
									</CardBody>
								</Card>
							</Col>
							<Col md={6}>
								<Card className='h-100'>
									<CardBody className='p-0'>
										<WorkLocationMap
											latitude={workData?.latitude}
											longitude={workData?.longitude}
											zoom={14}
											workCode={workData?.work_code}
											establishmentName={workData?.establishment}
										/>
									</CardBody>
								</Card>
							</Col>
						</Row>
							{/* Fila 6-7: Dos Tablas */}
							<Row className='mb-3'>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Actividades Programadas</h5>
										</CardHeader>
										<CardBody>
											<WorkScheduledActivitiesGrid workOrderId={id} />
										</CardBody>
									</Card>
								</Col>
								<Col md={6}>
									<Card className='h-100'>
										<CardHeader>
											<h5 className='card-title mb-0'>Detalle de Mediciones</h5>
										</CardHeader>
										<CardBody>
											<WorkMeasurementDetailsGrid workOrderId={id} />
										</CardBody>
									</Card>
								</Col>
							</Row>				</>
					)}				</Container>
			</div>
		</React.Fragment>
	);
};

export default WorkDetails;
